import { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconCheck = (props: PropsType) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style ? props.style : undefined}
    >
      <g mask='url(#mask0_1235_3833)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.022 1.17334C11.1895 1.17332 11.3501 1.23984 11.4685 1.35825L14.1484 4.03818C14.2668 4.15659 14.3334 4.31719 14.3333 4.48465C14.3333 4.6521 14.2668 4.81269 14.1484 4.93108L12.2848 6.79397C12.2791 6.80017 12.2732 6.80628 12.2672 6.8123C12.2611 6.81838 12.2549 6.82431 12.2487 6.83009L5.43458 13.6417C5.38122 13.697 5.31744 13.743 5.24551 13.7762C5.19793 13.7982 5.14818 13.814 5.09748 13.8235L1.75559 14.4944C1.54847 14.536 1.33429 14.4712 1.18492 14.3218C1.03555 14.1725 0.970781 13.9583 1.01236 13.7512L1.68244 10.4133C1.69749 10.3301 1.72932 10.2494 1.77793 10.1765C1.8022 10.14 1.83005 10.1065 1.8609 10.0762L8.67755 3.25708C8.68303 3.25116 8.68866 3.24531 8.69442 3.23956C8.70012 3.23385 8.7059 3.22828 8.71177 3.22284L10.5756 1.35833C10.694 1.2399 10.8546 1.17336 11.022 1.17334ZM9.14123 4.57918L2.8851 10.8376L2.43697 13.0698L4.66902 12.6217L10.9275 6.36546L9.14123 4.57918ZM11.8205 5.4728L10.0339 3.6862L11.0222 2.69755L12.8091 4.48451L11.8205 5.4728Z'
          fill={props.color ? props.color : '#E4E4E4'}
        />
      </g>
    </svg>
  );
};

export default SvgIconCheck;
